import { generatePath, useHistory, useLocation } from "react-router";

import type { GlobalLocationState } from "../../../../commons/types/location";

export {
  /** Re-export from original react-router for convenience */
  generatePath
};

/**
 * Typed wrapper around useLocation with GlobalLocationState as default.
 * Use the generic parameter to override with a specific location state type.
 *
 * @example
 * // Default usage - state is typed as GlobalLocationState
 * const location = useAppLocation();
 * const filters = location.state?.activeFilters;
 *
 * @example
 * // With specific state type
 * const location = useAppLocation<ZegPlusGarantieLocationState>();
 * const bicycleType = location.state?.bicycleTypeKey;
 */
export const useAppLocation = <S = GlobalLocationState>() => {
  return useLocation<S>();
};

/**
 * Typed wrapper around useHistory with GlobalLocationState as default.
 * Use the generic parameter to override with a specific location state type.
 *
 * @example
 * // Default usage - state is typed as GlobalLocationState
 * const history = useAppHistory();
 * history.push("/path", { backHref: "/previous" });
 *
 * @example
 * // With union type for multiple possible states
 * const history = useAppHistory<GlobalLocationState | BrowserLocationState>();
 */
export const useAppHistory = <S = GlobalLocationState>() => {
  return useHistory<S>();
};
